import * as i0 from '@angular/core';
import { Injectable, Pipe, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from 'base-letter-preview-library';
import { BaseLetterPreviewLibraryService } from 'base-letter-preview-library';
import * as i1$1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'app-services-library';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from '@angular/common';
import * as i7 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i8 from '@progress/kendo-angular-toolbar';
import * as i9 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i10 from 'primeng/button';
import * as i1 from '@angular/platform-browser';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { DateFormatModule } from 'date-format';
import * as i1$2 from 'angular-froala-wysiwyg';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

class LetterPreviewLibraryService {
    constructor() { }
}
LetterPreviewLibraryService.ɵfac = function LetterPreviewLibraryService_Factory(t) { return new (t || LetterPreviewLibraryService)(); };
LetterPreviewLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LetterPreviewLibraryService, factory: LetterPreviewLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterPreviewLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer)); };
SafeHtmlPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{ name: "safeHtml" }]
    }], function () { return [{ type: i1.DomSanitizer }]; }, null); })();

const _c0 = ["previewForm"];
const _c1 = ["letterpreviewupload"];
const _c2 = ["letterpreviewkendoeditor"];
function LetterPreviewLibraryComponent_h6_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Preview ", ctx_r1.letterType === "COVLTR" ? "Cover Letter" : "Support Letter", "");
} }
function LetterPreviewLibraryComponent_h6_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Edit ", ctx_r2.letterType === "COVLTR" ? "Cover Letter" : "Support Letter", "");
} }
function LetterPreviewLibraryComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 62);
    i0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 1, ctx_r3.previewLetter), i0.ɵɵsanitizeHtml);
} }
function LetterPreviewLibraryComponent_button_69_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 63);
    i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_button_69_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.editPreviewPDF(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
} }
function LetterPreviewLibraryComponent_button_70_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 64);
    i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_button_70_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.savePreviewPDF(); });
    i0.ɵɵelementEnd();
} }
function LetterPreviewLibraryComponent_div_74_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 67);
    i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_div_74_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.viewDocument(); });
    i0.ɵɵtext(1, "View Document");
    i0.ɵɵelementEnd();
} }
function LetterPreviewLibraryComponent_div_74_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 68);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Generated on ", ctx_r14.latestLetterGeneratedOn, "");
} }
function LetterPreviewLibraryComponent_div_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵtemplate(1, LetterPreviewLibraryComponent_div_74_button_1_Template, 2, 0, "button", 66);
    i0.ɵɵtemplate(2, LetterPreviewLibraryComponent_div_74_div_2_Template, 3, 1, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isLastestLetterAvailable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isLastestLetterAvailable);
} }
;
class LetterPreviewLibraryComponent extends BaseLetterPreviewLibraryService {
    constructor(store, apiService, toastr, appServicesLibraryService) {
        super(store, apiService, toastr, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        super.loadInit();
    }
    ngAfterViewInit() {
        this.previewForm = this.previewForm;
        super.ngAfterViewInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    letterpreviewimageuploaddialog() {
        this.letterpreviewupload.open();
    }
}
LetterPreviewLibraryComponent.ɵfac = function LetterPreviewLibraryComponent_Factory(t) { return new (t || LetterPreviewLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.APILetterPreview), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.AppServicesLibraryService)); };
LetterPreviewLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LetterPreviewLibraryComponent, selectors: [["letter-preview-library"]], viewQuery: function LetterPreviewLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.letterpreviewupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.letterpreviewkendoeditor = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose", letterpreviewkendoeditor: "letterpreviewkendoeditor" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 78, vars: 10, consts: [["previewForm", "ngForm"], [1, "row"], [4, "ngIf"], ["class", "mt-4 preview-comp", 3, "innerHtml", 4, "ngIf"], [1, "mt-4", 3, "hidden"], [1, "editor"], ["name", "coverLetterTextContent", 2, "height", "400px", 3, "value", "valueChange"], ["letterpreviewkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["letterpreviewupload", ""], [1, "row", "col-md-12", "dasheedTopBorder", "mt-3", "pt-3", "p-0"], [1, "col-md-1", "p-0"], ["color", "primary", 1, "pull-left", "backContBtn", 3, "click"], [1, "fa", "back-continue-icon", "fa-angle-left"], [1, "col-md-3", "p-0"], ["pButton", "", "type", "button", "label", "Edit Letter", "class", "im-btn im-btn-primary im-btn-md", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "type", "button", "label", "Save\n        Changes", "class", "im-btn im-btn-primary im-btn-md", 3, "click", 4, "ngIf"], [1, "col-md-3", "p-0", "text-right"], [1, "im-btn", "im-btn-primary", "im-btn-md", "align-top", 3, "disabled", "click"], ["class", "col-md-4 p-0 justify-content-center text-right centeralignitems", 4, "ngIf"], ["color", "primary", 1, "pull-right", "backContBtn", 3, "click"], [1, "fa", "back-continue-icon", "fa-angle-right"], [1, "mt-4", "preview-comp", 3, "innerHtml"], ["pButton", "", "type", "button", "label", "Edit Letter", 1, "im-btn", "im-btn-primary", "im-btn-md", 3, "disabled", "click"], ["pButton", "", "type", "button", "label", "Save\n        Changes", 1, "im-btn", "im-btn-primary", "im-btn-md", 3, "click"], [1, "col-md-4", "p-0", "justify-content-center", "text-right", "centeralignitems"], ["class", "im-btn im-btn-primary im-btn-md", 3, "click", 4, "ngIf"], [1, "im-btn", "im-btn-primary", "im-btn-md", 3, "click"], [1, "hint-text"]], template: function LetterPreviewLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", null, 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, LetterPreviewLibraryComponent_h6_3_Template, 3, 1, "h6", 2);
        i0.ɵɵtemplate(4, LetterPreviewLibraryComponent_h6_4_Template, 3, 1, "h6", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, LetterPreviewLibraryComponent_div_5_Template, 2, 3, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "kendo-editor", 6, 7);
        i0.ɵɵlistener("valueChange", function LetterPreviewLibraryComponent_Template_kendo_editor_valueChange_8_listener($event) { return ctx.previewLetter = $event; })("valueChange", function LetterPreviewLibraryComponent_Template_kendo_editor_valueChange_8_listener($event) { return ctx.previewLettereditorValueChange($event); });
        i0.ɵɵelementStart(10, "kendo-toolbar");
        i0.ɵɵelementStart(11, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(12, "kendo-toolbar-button", 8);
        i0.ɵɵelement(13, "kendo-toolbar-button", 9);
        i0.ɵɵelement(14, "kendo-toolbar-button", 10);
        i0.ɵɵelement(15, "kendo-toolbar-button", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(17, "kendo-toolbar-button", 12);
        i0.ɵɵelement(18, "kendo-toolbar-button", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(20, "kendo-toolbar-button", 14);
        i0.ɵɵelement(21, "kendo-toolbar-button", 15);
        i0.ɵɵelement(22, "kendo-toolbar-button", 16);
        i0.ɵɵelement(23, "kendo-toolbar-button", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(24, "kendo-toolbar-dropdownlist", 18);
        i0.ɵɵelement(25, "kendo-toolbar-dropdownlist", 19);
        i0.ɵɵelement(26, "kendo-toolbar-dropdownlist", 20);
        i0.ɵɵelement(27, "kendo-toolbar-colorpicker", 21);
        i0.ɵɵelement(28, "kendo-toolbar-colorpicker", 22);
        i0.ɵɵelementStart(29, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(30, "kendo-toolbar-button", 23);
        i0.ɵɵelement(31, "kendo-toolbar-button", 24);
        i0.ɵɵelement(32, "kendo-toolbar-button", 25);
        i0.ɵɵelement(33, "kendo-toolbar-button", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(34, "kendo-toolbar-button", 27);
        i0.ɵɵelement(35, "kendo-toolbar-button", 28);
        i0.ɵɵelementStart(36, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(37, "kendo-toolbar-button", 29);
        i0.ɵɵelement(38, "kendo-toolbar-button", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(40, "kendo-toolbar-button", 31);
        i0.ɵɵelement(41, "kendo-toolbar-button", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(42, "kendo-toolbar-button", 33);
        i0.ɵɵelement(43, "kendo-toolbar-button", 34);
        i0.ɵɵelement(44, "kendo-toolbar-button", 35);
        i0.ɵɵelement(45, "kendo-editor-insert-table-button");
        i0.ɵɵelementStart(46, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(47, "kendo-toolbar-button", 36);
        i0.ɵɵelement(48, "kendo-toolbar-button", 37);
        i0.ɵɵelement(49, "kendo-toolbar-button", 38);
        i0.ɵɵelement(50, "kendo-toolbar-button", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(52, "kendo-toolbar-button", 40);
        i0.ɵɵelement(53, "kendo-toolbar-button", 41);
        i0.ɵɵelement(54, "kendo-toolbar-button", 42);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(56, "kendo-toolbar-button", 43);
        i0.ɵɵelement(57, "kendo-toolbar-button", 44);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(58, "kendo-toolbar-button", 45);
        i0.ɵɵelementStart(59, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(60, "kendo-toolbar-button", 46);
        i0.ɵɵelementStart(61, "kendo-toolbar-button", 47);
        i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_Template_kendo_toolbar_button_click_61_listener() { return ctx.letterpreviewimageuploaddialog(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(62, "app-upload-image-dialog", 48, 49);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(64, "div", 50);
        i0.ɵɵelementStart(65, "div", 51);
        i0.ɵɵelementStart(66, "a", 52);
        i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_Template_a_click_66_listener() { return ctx.backLink(); });
        i0.ɵɵelement(67, "i", 53);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "div", 54);
        i0.ɵɵtemplate(69, LetterPreviewLibraryComponent_button_69_Template, 1, 1, "button", 55);
        i0.ɵɵtemplate(70, LetterPreviewLibraryComponent_button_70_Template, 1, 0, "button", 56);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "div", 57);
        i0.ɵɵelementStart(72, "button", 58);
        i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_Template_button_click_72_listener() { return ctx.generatePDFFile(); });
        i0.ɵɵtext(73, "Generate PDF");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(74, LetterPreviewLibraryComponent_div_74_Template, 3, 2, "div", 59);
        i0.ɵɵelementStart(75, "div", 51);
        i0.ɵɵelementStart(76, "a", 60);
        i0.ɵɵlistener("click", function LetterPreviewLibraryComponent_Template_a_click_76_listener() { return ctx.nextLink(); });
        i0.ɵɵelement(77, "i", 61);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(9);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.editPreview);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editPreview);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.editPreview);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.disabledControls || !ctx.editPreview);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("value", ctx.previewLetter);
        i0.ɵɵadvance(54);
        i0.ɵɵproperty("editor", _r4);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", !ctx.editPreview);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editPreview);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
    } }, directives: [i5.ɵangular_packages_forms_forms_ba, i5.NgControlStatusGroup, i5.NgForm, i6.NgIf, i7.EditorComponent, i8.ToolBarComponent, i8.ToolBarButtonGroupComponent, i8.ToolBarButtonComponent, i7.EditorBoldButtonDirective, i7.EditorItalicButtonDirective, i7.EditorUnderlineButtonDirective, i7.EditorStrikethroughButtonDirective, i7.EditorSubscriptButtonDirective, i7.EditorSuperscriptButtonDirective, i7.EditorAlignLeftButtonDirective, i7.EditorAlignCenterButtonDirective, i7.EditorAlignRightButtonDirective, i7.EditorAlignJustifyButtonDirective, i7.EditorFormatComponent, i7.EditorFontSizeComponent, i7.EditorFontFamilyComponent, i7.EditorColorPickerComponent, i7.EditorForeColorDirective, i7.EditorBackColorDirective, i7.EditorInsertUnorderedListButtonDirective, i7.EditorInsertOrderedListButtonDirective, i7.EditorIndentButtonDirective, i7.EditorOutdentButtonDirective, i7.EditorBlockquoteDirective, i7.EditorSelectAllButtonDirective, i7.EditorUndoButtonDirective, i7.EditorRedoButtonDirective, i7.EditorCreateLinkButtonDirective, i7.EditorUnlinkButtonDirective, i7.EditorInsertFileButtonDirective, i7.EditorViewSourceButtonDirective, i7.EditorCleanFormattingButtonDirective, i7.EditorInsertTableButtonComponent, i7.EditorAddColumnBeforeButtonDirective, i7.EditorAddColumnAfterButtonDirective, i7.EditorAddRowBeforeButtonDirective, i7.EditorAddRowAfterButtonDirective, i7.EditorDeleteColumnButtonDirective, i7.EditorDeleteRowButtonDirective, i7.EditorDeleteTableButtonDirective, i7.EditorMergeCellsButtonDirective, i7.EditorSplitCellButtonDirective, i7.EditorPrintDirective, i7.EditorInsertImageButtonDirective, i9.UploadImageDialogComponent, i10.ButtonDirective], pipes: [SafeHtmlPipe], styles: [".step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.editor[_ngcontent-%COMP%]{margin-top:50px}.centeralignitems[_ngcontent-%COMP%]{display:grid;align-items:center!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterPreviewLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'letter-preview-library',
                templateUrl: 'letter-preview-library.component.html',
                styleUrls: ['letter-preview-library.component.scss']
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.APILetterPreview }, { type: i3.ToastrService }, { type: i4.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], previewForm: [{
            type: ViewChild,
            args: ['previewForm', { static: false }]
        }], letterpreviewupload: [{
            type: ViewChild,
            args: ["letterpreviewupload"]
        }], letterpreviewkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["letterpreviewkendoeditor"]
        }] }); })();

class LetterPreviewLibraryModule {
}
LetterPreviewLibraryModule.ɵfac = function LetterPreviewLibraryModule_Factory(t) { return new (t || LetterPreviewLibraryModule)(); };
LetterPreviewLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LetterPreviewLibraryModule });
LetterPreviewLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseLetterPreviewLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            DateFormatModule,
            FormsModule,
            FroalaEditorModule.forRoot(),
            FroalaViewModule.forRoot(),
            EditorModule,
            EditorLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LetterPreviewLibraryModule, { declarations: [LetterPreviewLibraryComponent, SafeHtmlPipe], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        DateFormatModule,
        FormsModule, i1$2.FroalaEditorModule, i1$2.FroalaViewModule, EditorModule,
        EditorLibraryModule], exports: [LetterPreviewLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterPreviewLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LetterPreviewLibraryComponent, SafeHtmlPipe],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    DateFormatModule,
                    FormsModule,
                    FroalaEditorModule.forRoot(),
                    FroalaViewModule.forRoot(),
                    EditorModule,
                    EditorLibraryModule
                ],
                providers: [BaseLetterPreviewLibraryService],
                exports: [LetterPreviewLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of letter-preview-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LetterPreviewLibraryComponent, LetterPreviewLibraryModule, LetterPreviewLibraryService, SafeHtmlPipe };
//# sourceMappingURL=letter-preview-library.js.map
